import axios from 'axios';

const tokenElement = document.getElementsByName('csrf-token')[0];
const token = tokenElement ? tokenElement.getAttribute('content') : null;
axios.defaults.headers.common['X-CSRF-Token'] = token;
axios.defaults.headers.common.Accept = 'application/json';
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location = '/users/sign_in?unauth=1';
    }
    return Promise.reject(error);
  }
);
export default axios;
